@let category = block();
@let titleLevelData = titleLevel();

@if (category.content.image?.filename?.length) {
    <div class="s1-categories-preview--image-wrapper">
        <img class="s1-categories-preview--image"
             [ngSrc]="category.content.image!.filename"
             [fill]="true"
             [alt]="category.content.image?.alt"
             [title]="category.content.image?.title"
        >
    </div>
}
<div class="s1-categories-preview--content">
    <div>
        @switch (titleLevelData && +titleLevelData){
            @case (1){
                <h1>
                    {{ category.content.title }}
                </h1>
            }
            @case (2){
                <h2>
                    {{ category.content.title }}
                </h2>
            }
            @case (3){
                <h3>
                    {{ category.content.title }}
                </h3>
            }

            @case (4){
                <h4>
                    {{ category.content.title }}
                </h4>
            }
            @case (5){
                <h5>
                    {{ category.content.title }}
                </h5>
            }
            @case (6){
                <h6>
                    {{ category.content.title }}
                </h6>
            }
            @default {
                <h2>
                    {{ category.content.title }}
                </h2>
            }

        }
        <p class="s1-categories-preview--paragraph">
            {{ category.content.description }}
        </p>
    </div>
    <s1-button [block]="{
        link: {
           linktype: 'story',
           cached_url: category.full_slug
        },
        size: 'default',
        text: 'Zu den Beiträgen',
        color: 'accent-light',
        marginX: 'auto'
    }"/>
</div>

